// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMultipleCardsPath = 'M87.704 8h-68.08c-6.606 0-11.96 5.355-11.96 11.96v16.263L1.233 68.026l-.066.355a11.79 11.79 0 009.324 13.542L74.27 94.82l.294.055c6.276 1.1 12.317-2.994 13.59-9.27l3.34-16.22c4.748-1.584 8.17-6.066 8.17-11.346V19.96c0-6.605-5.355-11.96-11.96-11.96zM8.094 69.412l1.111-5.494A11.956 11.956 0 0019.624 70H84.22l-2.925 14.204-.049.215a4.792 4.792 0 01-5.593 3.54l-63.787-12.9-.25-.056a4.794 4.794 0 01-3.523-5.591zM19.624 15h68.08a4.96 4.96 0 014.96 4.96V22h-78v-2.04a4.96 4.96 0 014.96-4.96zm-4.96 14v7h78v-7h-78zm0 14v15.04a4.96 4.96 0 004.96 4.96h68.08a4.96 4.96 0 004.96-4.96V43h-78z';
var IllustrationMultipleCards = baseIllustration('IllustrationMultipleCards', {
  getPath: () => IllustrationMultipleCardsPath
}, 'ColoredIllustrationMultipleCards');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMultipleCards;
//# sourceMappingURL=index.js.map